import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  MaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import {
  Box,
  Button,
  IconButton,
  Grid,
  TextField,
  Paper,
  Chip,
  Switch,
  Typography,
  Checkbox,
  Card,
  CardActions
} from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CloseIcon from '@mui/icons-material/Close';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { ToastContainer } from 'react-toastify';
import './CreateUser.css';
import {
  GetUserRoles,
  CreateAgencyRole,
  GetRolePermissions
} from '../../apis/Agency';
import { successToast, ErrorToast } from '../../components/Toasts';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { MetaTags } from 'react-meta-tags';
import { base_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function RoleManagement(props) {
  console.log(props, 'props');
  const actionFrom = props.location?.state?.from || '';
  const selectedUser = props.location?.state?.selectedUser || null;
  const agencyLocations = props.location?.state?.agencyLocations || null;
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  const [currentView, setCurrentView] = useState('list');
  const [adminRoles, setAdminRoles] = useState(null);
  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const [createRole, setCreateRole] = useState(false);
  const [userRoleName, setUserRoleName] = useState('');
  const [editedRolePermissionID, setEditedRolePermissionID] = useState('');
  const [selectAllSwitch, setSelectAllSwitch] = useState(false);
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [disableCreateUserBtn, setDisableCreateUserBtn] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [rows, setRows] = useState([]);
  const history = useHistory();

  function createData(
    permissionName,
    status,
    level1,
    level2,
    level3,
    level4,
    level5,
    level6,
    level7,
    level8,
    level9,
    level10,
    level11,
    level12,
    level13
  ) {
    return {
      permissionName,
      status,
      level1,
      level2,
      level3,
      level4,
      level5,
      level6,
      level7,
      level8,
      level9,
      level10,
      level11,
      level12,
      level13
    };
  }

  const initialRows = [
    createData(
      'Dashboard',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'LTL Carriers',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'TL Carriers',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Parcel Carriers',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Users',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Roles',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Manage-Shipments',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),

    createData(
      'Locations',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Reports',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Settings',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'App-Registration',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Track-Shipments',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Quick Quote',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ),
    createData(
      'Logs',
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    )
  ];

  useEffect(() => {
    setCurrentView(actionFrom === 'user-management' ? 'create' : 'list');
  }, [actionFrom]);

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Roles'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
  }, [userRolePermissions]);

  useEffect(() => {
    setRows(initialRows);
  }, []);

  const fetchUserRoles = () => {
    GetUserRoles(AgencyID)
      .then(response => {
        if (response.status === 200) {
          setShipmentsLoader(false);
          setAdminRoles(
            response?.data?.data.filter(item => item.roleName !== 'Default')
          );
        }
      })
      .catch(err => {
        setShipmentsLoader(false);
        console.log('eeeeeeeee', err.message);
      });
  };

  useEffect(() => {
    fetchUserRoles();
  }, []);

  const handleCreateRoleRequest = () => {
    const hasAnyPermission = rows.some(module =>
      Object.values(module).some(value => value === true)
    );
    let errors = {};

    if (!hasAnyPermission) {
      errors['userRoleNameError'] =
        'Assign at least one module. Empty role cannot be created!';
      setValidationErrors(errors);
    }
    if (!userRoleName) {
      errors['userRoleNameError'] = 'Enter role name';
      setValidationErrors(errors);
    }
    if (!/^[a-zA-Z0-9 ]*$/.test(userRoleName)) {
      let errors = {};
      errors['userRoleNameError'] =
        'Role name should contain only alphanumeric characters';
      setValidationErrors(errors);
    } else {
      const roleObj = {
        id: editedRolePermissionID ? editedRolePermissionID : 0,
        name: userRoleName,
        status: true,
        agencyId: AgencyID,
        permissions: rows,
        permissionsDetails: JSON.stringify(rows)
      };

      if (userRoleName && hasAnyPermission) {
        setDisableCreateUserBtn(true);
        CreateAgencyRole(roleObj)
          .then(res => {
            res.status === 200 && fetchUserRoles();
            successToast(
              editedRolePermissionID
                ? 'Role updated successfully!'
                : 'Role created successfully!'
            );
            if (actionFrom === 'user-management') {
              setTimeout(() => {
                history.push({
                  pathname: '/users',
                  state: {
                    from: 'role-management',
                    selectedUser: selectedUser,
                    agencyLocations: agencyLocations
                  }
                });
              }, 1500);
            } else {
              setCurrentView('list');
              setSelectAllSwitch(false);
              setDisableCreateUserBtn(false);
            }
          })

          .catch(err => {
            setDisableCreateUserBtn(false);
            ErrorToast(err?.message);
          });
      }
    }
  };

  const handleCreateRole = () => {
    setCreateRole(true);
    setCurrentView('create');
    setRows(initialRows);
    setUserRoleName('');
    setEditedRolePermissionID('');
  };

  const RolesPermissionsSuccessResponse = (apiRes, rowData) => {
    let selectAllCheck = [];
    const permissionsArr = apiRes[0]?.permissions
      ? JSON.parse(apiRes[0]?.permissions)
      : apiRes;
    const updatedPermissions = permissionsArr.map(permission => {
      const allLevelsTrue =
        permission.permissionName === 'Manage-Shipments'
          ? permission.level1 &&
            permission.level2 &&
            permission.level3 &&
            permission.level4 &&
            permission.level5 &&
            permission.level6 &&
            permission.level7 &&
            permission.level8 &&
            permission.level9 &&
            permission.level10 &&
            permission.level11 && // ✅ Make sure these exist
            permission.level12 &&
            permission.level13
          : permission.level1 &&
            permission.level2 &&
            permission.level3 &&
            permission.level4 &&
            permission.level5;

      if (allLevelsTrue) {
        selectAllCheck.push(allLevelsTrue);
        if (selectAllCheck.length == 10) {
          setSelectAllSwitch(true);
        }
      } else {
        setSelectAllSwitch(false);
      }
      return {
        ...permission,
        status: allLevelsTrue ? true : false
      };
    });

    const mergedRows = initialRows.map(initialRow => {
      const updatedPermission = updatedPermissions.find(
        permission =>
          permission.permissionName.toLowerCase() ===
          initialRow.permissionName.toLowerCase()
      );

      if (updatedPermission) {
        return {
          permissionName: initialRow.permissionName,
          status: updatedPermission.status,
          level1: updatedPermission.level1,
          level2: updatedPermission.level2,
          level3: updatedPermission.level3,
          level4: updatedPermission.level4,
          level5: updatedPermission.level5,
          level6: updatedPermission.level6,
          level7: updatedPermission.level7,
          level8: updatedPermission.level8,
          level9: updatedPermission.level9,
          level10: updatedPermission.level10,
          level11: updatedPermission.level11,
          level12: updatedPermission.level12,
          level13: updatedPermission.level13
        };
      }

      return initialRow;
    });

    setRows(mergedRows);
    setUserRoleName(rowData.roleName);
    setEditedRolePermissionID(rowData.id);
    setCreateRole(true);
    setCurrentView('create');
  };

  const handleGetUserPermissionsRequest = rowData => {
    GetRolePermissions(rowData.id)
      .then(res => {
        res.status === 200 &&
          RolesPermissionsSuccessResponse(res.data.data, rowData);
      })
      .catch(err => console.log(err, 'user permissions Err----->>>>'));
  };

  const handleEditRolesAndPermissions = (event, rowData) => {
    event.stopPropagation();
    handleGetUserPermissionsRequest(rowData);
  };
  const hasPermissionForAction = () => {
    if (UserIsAdmin) return true;
    if (!userPermissionsArr) return false;

    if (editedRolePermissionID) {
      return userPermissionsArr.some(permission => permission.level4);
    } else {
      return userPermissionsArr.some(permission => permission.level3);
    }
  };
  const permissionsColumns = [
    {
      accessorKey: 'roleName',
      id: 'rolename',
      header: 'Role Name',
      size: 770,
      Cell: ({ cell, row }) => (
        <>
          <Box
            onClick={e => e.stopPropagation()}
            sx={
              isMobile
                ? { display: 'flex', alignItems: 'center', height: '8vw' }
                : { display: 'flex', alignItems: 'center', height: '2vw' }
            }
          >
            <span class='mx-1'>{cell.getValue()}</span>
          </Box>
          <div
            className='table-row-buttons-users py-2'
            style={{ marginLeft: '-4vw' }}
          >
            {!isMobile &&
              ((userPermissionsArr &&
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length) ||
                userPermissionsArr.filter(permissions => permissions.level2)
                  .length ||
                UserIsAdmin) && (
                <button
                  onClick={event =>
                    handleEditRolesAndPermissions(event, row.original)
                  }
                  class='mx-2 bg-white border-0 p-2 fw-bold'
                  style={{ color: '#3361FF', borderRadius: '4px' }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='MX-2 '
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Tooltip>
                </button>
              )}
          </div>
        </>
      )
    }
  ];

  const handlePrint = () => {};

  useEffect(() => {
    const allChecked = rows.every(row => row.status);
    setSelectAllSwitch(allChecked);
  }, [rows]);

  const handleCheckboxChange = (index, field, status) => {
    setValidationErrors({
      ...validationErrors,
      userRoleNameError: null
    });

    setRows(prevRows => {
      if (!Array.isArray(prevRows) || prevRows.length <= index) {
        return prevRows;
      }

      const newRows = [...prevRows];
      const targetRow = newRows[index];

      if (!targetRow) {
        return prevRows;
      }

      targetRow[field] = status;

      const isManageShipments = targetRow.permissionName === 'Manage-Shipments';
      const maxLevel = isManageShipments ? 13 : 10;

      // Handle status change (master checkbox)
      if (field === 'status') {
        // Set all applicable levels
        for (let i = 1; i <= maxLevel; i++) {
          targetRow[`level${i}`] = status;
        }
      }

      // When level1 is turned off for non-special permissions
      if (
        field === 'level1' &&
        !status &&
        targetRow.permissionName !== 'Quick Quote' &&
        targetRow.permissionName !== 'Dashboard'
      ) {
        for (let i = 1; i <= maxLevel; i++) {
          targetRow[`level${i}`] = status;
        }
      }

      // If any level is turned off, status should be false
      if (field.startsWith('level') && !status) {
        targetRow['status'] = false;
      }

      // Check if all levels are true to set status true
      let allLevelsSelected = true;
      for (let i = 1; i <= maxLevel; i++) {
        if (!targetRow[`level${i}`]) {
          allLevelsSelected = false;
          break;
        }
      }

      if (allLevelsSelected && status) {
        targetRow['status'] = true;
      }

      // Special case: level2 turning off also turns off level4
      if (
        field === 'level2' &&
        !status &&
        targetRow.permissionName !== 'Quick Quote' &&
        targetRow.permissionName !== 'Dashboard' &&
        !isManageShipments
      ) {
        targetRow['level4'] = false;
      }

      // Quick Quote specific logic
      if (targetRow.permissionName === 'Quick Quote') {
        if (
          !targetRow['level1'] &&
          !targetRow['level3'] &&
          !targetRow['level4']
        ) {
          targetRow['level5'] = false;
        }
      }

      return newRows;
    });
  };

  const handleSwitchChange = event => {
    setValidationErrors({
      ...validationErrors,
      userRoleNameError: null
    });
    const status = event.target.checked;
    setSelectAllSwitch(status);
    setRows(prevRows => {
      const allChecked = !prevRows.every(row => row.status);
      return prevRows.map(row => {
        return {
          ...row,
          status: allChecked,
          level1: allChecked,
          level2: allChecked,
          level3: allChecked,
          level4: allChecked,
          level5: allChecked,
          level6: allChecked,
          level7: allChecked,
          level8: allChecked,
          level9: allChecked,
          level10: allChecked,
          level11: allChecked,
          level12: allChecked,
          level13: allChecked
        };
      });
    });
  };

  const isMobile = useIsMobile();

  const renderRoleForm = () => (
    <Card
      sx={
        isMobile
          ? {
              display: 'flex',
              flexDirection: 'column',
              width: '90vw',
              height: '90vh',
              justifyContent: 'flex-start',
              overflow: 'hidden'
            }
          : {
              justifyContent: 'center',
              height: '89vh',
              p: 1,
              display: 'flex',
              flexDirection: 'column'
            }
      }
      className={isMobile ? 'Grid_Item_User_mobile' : 'Grid_Item_Create_Role'}
    >
      {/* Header with Close Button */}
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          position: 'relative',
          flexShrink: 0,
          p: 1
        }}
      >
        <IconButton
          aria-label='delete'
          onClick={() => {
            if (actionFrom === 'user-management') {
              history.push({
                pathname: '/users',
                state: {
                  from: 'role-management',
                  selectedUser: selectedUser,
                  agencyLocations: agencyLocations
                }
              });
            }
            setCurrentView('list');
            setSelectAllSwitch(false);
            setValidationErrors({});
          }}
        >
          <CloseIcon color='error' />
        </IconButton>
      </Grid>

      {/* Main Content Area - Scrollable */}
      <Grid
        sx={{
          px: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <TextField
          disabled={
            (userPermissionsArr &&
              (userPermissionsArr.filter(permissions => permissions.level3)
                .length ||
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length)) ||
            UserIsAdmin
              ? false
              : true
          }
          FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
          error={Boolean(validationErrors['userRoleNameError'])}
          helperText={validationErrors['userRoleNameError']}
          fullWidth
          size='small'
          label='Role Name'
          value={userRoleName}
          onChange={e => {
            setUserRoleName(e.target.value);
            setValidationErrors({
              ...validationErrors,
              userRoleNameError: null
            });
          }}
          sx={{ my: 2, flexShrink: 0 }}
        />

        <Grid
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          {/* Select All Chip */}
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: 1,
              flexShrink: 0
            }}
          >
            <Chip
              size='small'
              variant='outlined'
              label={
                <div>
                  <Typography variant='button' fontSize={12}>
                    Select All
                  </Typography>{' '}
                  <Switch
                    disabled={
                      (userPermissionsArr &&
                        (userPermissionsArr.filter(
                          permissions => permissions.level3
                        ).length ||
                          userPermissionsArr.filter(
                            permissions => permissions.level4
                          ).length)) ||
                      UserIsAdmin
                        ? false
                        : true
                    }
                    checked={selectAllSwitch}
                    size='small'
                    onChange={handleSwitchChange}
                  />
                </div>
              }
            />
          </Grid>

          {/* Scrollable Table Container */}
          <Grid sx={{ flex: 1, overflow: 'hidden' }}>
            <TableContainer
              component={Paper}
              sx={{
                height: '100%',
                overflow: 'auto',
                '& .MuiTable-root': {
                  minWidth: isMobile ? '800px' : 'auto'
                }
              }}
            >
              <Table stickyHeader size='small' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell>Module</TableCell>
                    <TableCell align='center'>All</TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                    <TableCell align='center'></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={row.permissionName}
                      sx={{
                        whiteSpace: 'nowrap',
                        '&:last-child td, &:last-child th': {
                          border: 0
                        }
                      }}
                    >
                      <TableCell component='th' scope='row'>
                        {row.permissionName}
                      </TableCell>
                      <TableCell align='center'>
                        <Checkbox
                          disabled={
                            (userPermissionsArr &&
                              (userPermissionsArr.filter(
                                permissions => permissions.level3
                              ).length ||
                                userPermissionsArr.filter(
                                  permissions => permissions.level4
                                ).length)) ||
                            UserIsAdmin
                              ? false
                              : true
                          }
                          size='small'
                          checked={row.status}
                          onChange={e =>
                            handleCheckboxChange(
                              index,
                              'status',
                              e.target.checked
                            )
                          }
                        />
                      </TableCell>
                      {row.permissionName !== 'Track-Shipments' ? (
                        row.permissionName === 'Manage-Shipments' ? (
                          <>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Listings
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level1}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level1',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Details
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level2}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level2',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>

                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Book
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level3}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level3',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Cancel
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level4}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level4',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                View Tendered
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level5}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level5',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>

                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Dispatched
                              </Typography>
                              {row.level6}
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level6}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level6',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                UnBook
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level7}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level7',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Hold/UnHold
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level8}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level8',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Update
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level9}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level9',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Mark as deliver
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level10}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level10',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Create Claim
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level11}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level11',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Update Claim
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level12}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level12',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Claim Details
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level13}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level13',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell>
                            {/* <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Claim Details
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level13}
                                onChange={e =>
                                  handleCheckboxChange(
                                    index,
                                    'level13',
                                    e.target.checked
                                  )
                                }
                              />
                            </TableCell> */}
                          </>
                        ) : row.permissionName === 'Locations' ? (
                          <>
                            <TableCell align='right'>
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Listings
                              </Typography>
                              <Checkbox
                                disabled={
                                  (userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                  UserIsAdmin
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level1}
                                onChange={e => {
                                  [
                                    'level1',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              <Typography sx={{ m: 0 }} variant='caption'>
                                View
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level2}
                                onChange={e => {
                                  [
                                    'level2',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            {
                              <>
                                {
                                  <TableCell align='right'>
                                    <Typography sx={{ m: 0 }} variant='caption'>
                                      Create
                                    </Typography>
                                    <Checkbox
                                      size='small'
                                      checked={
                                        row.permissionName ===
                                        'Manage-Shipments'
                                          ? false
                                          : row.level3
                                      }
                                      disabled={
                                        row.permissionName ===
                                        'Manage-Shipments'
                                          ? true
                                          : ((userPermissionsArr &&
                                                (userPermissionsArr.filter(
                                                  permissions =>
                                                    permissions.level3
                                                ).length ||
                                                  userPermissionsArr.filter(
                                                    permissions =>
                                                      permissions.level4
                                                  ).length)) ||
                                                UserIsAdmin) &&
                                              row.level1
                                            ? false
                                            : true
                                      }
                                      onChange={e => {
                                        [
                                          'level3',
                                          'level7',
                                          'level8',
                                          'level9',
                                          'level10'
                                        ].forEach(level =>
                                          handleCheckboxChange(
                                            index,
                                            level,
                                            e.target.checked
                                          )
                                        );
                                      }}
                                    />
                                  </TableCell>
                                }
                                <TableCell align='right'>
                                  <Typography sx={{ m: 0 }} variant='caption'>
                                    Update
                                  </Typography>
                                  <Checkbox
                                    size='small'
                                    checked={row.level4}
                                    disabled={
                                      ((userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                        UserIsAdmin) &&
                                      row.level1
                                        ? false
                                        : true
                                    }
                                    onChange={e => {
                                      [
                                        'level2',
                                        'level4',
                                        'level7',
                                        'level8',
                                        'level9',
                                        'level10'
                                      ].forEach(level =>
                                        handleCheckboxChange(
                                          index,
                                          level,
                                          e.target.checked
                                        )
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell align='right'>
                                  <Typography sx={{ m: 0 }} variant='caption'>
                                    Default
                                  </Typography>
                                  <Checkbox
                                    size='small'
                                    checked={row.level5}
                                    disabled={
                                      ((userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                        UserIsAdmin) &&
                                      row.level1
                                        ? false
                                        : true
                                    }
                                    onChange={e => {
                                      [
                                        'level5',
                                        'level7',
                                        'level8',
                                        'level9',
                                        'level10'
                                      ].forEach(level =>
                                        handleCheckboxChange(
                                          index,
                                          level,
                                          e.target.checked
                                        )
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell align='right'>
                                  <Typography sx={{ m: 0 }} variant='caption'>
                                    Home
                                  </Typography>
                                  <Checkbox
                                    size='small'
                                    checked={row.level6}
                                    disabled={
                                      ((userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                        UserIsAdmin) &&
                                      row.level1
                                        ? false
                                        : true
                                    }
                                    onChange={e => {
                                      [
                                        'level6',
                                        'level7',
                                        'level8',
                                        'level9',
                                        'level10'
                                      ].forEach(level =>
                                        handleCheckboxChange(
                                          index,
                                          level,
                                          e.target.checked
                                        )
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell>
                              </>
                            }
                          </>
                        ) : row.permissionName === 'Logs' ? (
                          <>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Shipment Logs
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level1}
                                onChange={e => {
                                  [
                                    'level1',
                                    'level4',
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Details
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level2}
                                onChange={e => {
                                  [
                                    'level2',
                                    'level4',
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Request
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level3}
                                onChange={e => {
                                  [
                                    'level3',
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                          </>
                        ) : row.permissionName === 'Quick Quote' ? (
                          <>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                LTL
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level1}
                                onChange={e => {
                                  [
                                    'level1',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                TL
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level2}
                                onChange={e => {
                                  [
                                    'level2',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Parcel
                              </Typography>
                              <Checkbox
                                size='small'
                                // disabled={row.level1 ? false : true}
                                checked={row.level3}
                                onChange={e => {
                                  [
                                    'level3',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                LTL/Parcel
                              </Typography>
                              <Checkbox
                                size='small'
                                // disabled={row.level1 ? false : true}
                                checked={row.level4}
                                onChange={e => {
                                  [
                                    'level4',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Pickup
                              </Typography>
                              <Checkbox
                                disabled={
                                  row.level1 || row.level3 || row.level4
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level5}
                                onChange={e => {
                                  [
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                          </>
                        ) : row.permissionName === 'Dashboard' ? (
                          <>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Freight Spend
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level1}
                                onChange={e => {
                                  ['level1', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                # of Shipments
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level2}
                                onChange={e => {
                                  ['level2', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Origin
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level3}
                                onChange={e => {
                                  ['level3', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Destination
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level4}
                                onChange={e => {
                                  ['level4', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                OnTime Delivery
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level5}
                                onChange={e => {
                                  [
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                OT-Late Shipments
                              </Typography>
                              <Checkbox
                                size='small'
                                disabled={row.level5 ? false : true}
                                checked={row.level6}
                                onChange={e => {
                                  ['level6', 'level7', 'level10'].forEach(
                                    level =>
                                      handleCheckboxChange(
                                        index,
                                        level,
                                        e.target.checked
                                      )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                OT-View Details
                              </Typography>
                              <Checkbox
                                size='small'
                                disabled={row.level6 ? false : true}
                                checked={row.level7}
                                onChange={e => {
                                  ['level7', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Weekly Trend
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level8}
                                onChange={e => {
                                  ['level8', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              {' '}
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Claims
                              </Typography>
                              <Checkbox
                                size='small'
                                checked={row.level9}
                                onChange={e => {
                                  ['level9', 'level10'].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                            <TableCell align='center'></TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell align='right'>
                              <Typography sx={{ m: 0 }} variant='caption'>
                                Listings
                              </Typography>
                              <Checkbox
                                disabled={
                                  (userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                  UserIsAdmin
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level1}
                                onChange={e => {
                                  [
                                    'level1',
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align='right'>
                              <Typography sx={{ m: 0 }} variant='caption'>
                                View
                              </Typography>
                              <Checkbox
                                disabled={
                                  ((userPermissionsArr &&
                                    (userPermissionsArr.filter(
                                      permissions => permissions.level3
                                    ).length ||
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length)) ||
                                    UserIsAdmin) &&
                                  row.level1
                                    ? false
                                    : true
                                }
                                size='small'
                                checked={row.level2}
                                onChange={e => {
                                  [
                                    'level2',
                                    'level5',
                                    'level6',
                                    'level7',
                                    'level8',
                                    'level9',
                                    'level10'
                                  ].forEach(level =>
                                    handleCheckboxChange(
                                      index,
                                      level,
                                      e.target.checked
                                    )
                                  );
                                }}
                              />
                            </TableCell>

                            <>
                              {row.permissionName !== 'LTL Carriers' &&
                                row.permissionName !== 'Parcel Carriers' && (
                                  <TableCell align='right'>
                                    <Typography sx={{ m: 0 }} variant='caption'>
                                      Create
                                    </Typography>
                                    <Checkbox
                                      size='small'
                                      checked={
                                        row.permissionName ===
                                        'Manage-Shipments'
                                          ? false
                                          : row.level3
                                      }
                                      disabled={
                                        row.permissionName ===
                                        'Manage-Shipments'
                                          ? true
                                          : ((userPermissionsArr &&
                                                (userPermissionsArr.filter(
                                                  permissions =>
                                                    permissions.level3
                                                ).length ||
                                                  userPermissionsArr.filter(
                                                    permissions =>
                                                      permissions.level4
                                                  ).length)) ||
                                                UserIsAdmin) &&
                                              row.level1
                                            ? false
                                            : true
                                      }
                                      onChange={e => {
                                        [
                                          'level3',
                                          'level5',
                                          'level6',
                                          'level7',
                                          'level8',
                                          'level9',
                                          'level10'
                                        ].forEach(level =>
                                          handleCheckboxChange(
                                            index,
                                            level,
                                            e.target.checked
                                          )
                                        );
                                      }}
                                    />
                                  </TableCell>
                                )}
                              <TableCell align='right'>
                                <Typography sx={{ m: 0 }} variant='caption'>
                                  Update
                                </Typography>
                                <Checkbox
                                  size='small'
                                  checked={row.level4}
                                  disabled={
                                    ((userPermissionsArr &&
                                      (userPermissionsArr.filter(
                                        permissions => permissions.level3
                                      ).length ||
                                        userPermissionsArr.filter(
                                          permissions => permissions.level4
                                        ).length)) ||
                                      UserIsAdmin) &&
                                    row.level1
                                      ? false
                                      : true
                                  }
                                  onChange={e => {
                                    [
                                      'level2',
                                      'level3',
                                      'level4',
                                      'level5',
                                      'level6',
                                      'level7',
                                      'level8',
                                      'level9',
                                      'level10'
                                    ].forEach(level =>
                                      handleCheckboxChange(
                                        index,
                                        level,
                                        e.target.checked
                                      )
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                              <TableCell align='center'></TableCell>
                            </>
                          </>
                        )
                      ) : (
                        <>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='right'></TableCell>
                          <TableCell align='center'></TableCell>
                          <TableCell align='center'></TableCell>
                          <TableCell align='center'></TableCell>
                          <TableCell align='right'></TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>

      {/* Fixed Button - Always Visible */}
      <CardActions
        sx={{
          p: 2,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          flexShrink: 0,
          backgroundColor: 'background.paper',
          position: 'sticky',
          bottom: 0,
          zIndex: 10
        }}
      >
        <Button
          fullWidth={isMobile}
          disabled={!hasPermissionForAction()}
          onClick={handleCreateRoleRequest}
          sx={{
            backgroundColor: '#3361FF',
            width: isMobile ? '100%' : 'auto',
            minWidth: 120,
            '&:hover': {
              backgroundColor: '#2951E0'
            }
          }}
          variant='contained'
        >
          {editedRolePermissionID ? 'Update' : 'Create'}
        </Button>
      </CardActions>
    </Card>
  );

  const renderRoleList = () => (
    <div class={isMobile ? 'mt-1 mx-2' : 'mt-2 mx-3'} style={{ border: '' }}>
      {adminRoles && (
        <MaterialReactTable
          state={{ isLoading: shipmentsLoader }}
          columns={permissionsColumns}
          data={adminRoles}
          enableRowSelection
          muiTableBodyRowProps={({ row }) => ({
            onClick: row.getToggleSelectedHandler()
          })}
          muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
          muiTableContainerProps={{
            sx: { maxHeight: '70vh', minHeight: '70vh' }
          }}
          initialState={{
            density: 'compact'
          }}
          positionToolbarAlertBanner='bottom'
          renderToolbarInternalActions={({ table }) => (
            <div style={isMobile ? { fontSize: 10 } : {}}>
              <MRT_ToggleGlobalFilterButton table={table} title='Search' />
              <IconButton
                title='Print'
                onClick={() => {
                  handlePrint();
                }}
              >
                <LocalPrintshopOutlinedIcon />
              </IconButton>
              <MRT_ToggleFiltersButton table={table} title='Filters' />
              <MRT_ToggleDensePaddingButton table={table} title='Spacing' />
              <MRT_ShowHideColumnsButton
                table={table}
                title='Show/Hide Columns'
              />
              <MRT_FullScreenToggleButton table={table} title='Fullscreen' />
              <Tooltip title='Clear All Filters' arrow>
                <IconButton
                  onClick={() => {
                    table.resetColumnFilters(true);
                    table.setShowColumnFilters(false);
                  }}
                >
                  <FilterAltOffIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
          enableRowActions={isMobile ? true : false}
          renderRowActions={({ row, table }) =>
            ((userPermissionsArr &&
              userPermissionsArr.filter(permissions => permissions.level4)
                .length) ||
              userPermissionsArr.filter(permissions => permissions.level2)
                .length ||
              UserIsAdmin) && (
              <button
                onClick={event =>
                  handleEditRolesAndPermissions(event, row.original)
                }
                class='mx-2 bg-white border-0 p-2 fw-bold'
                style={{ color: '#3361FF', borderRadius: '4px' }}
              >
                <Tooltip title='View / Update'>
                  <svg
                    className='MX-2 '
                    width='17'
                    height='17'
                    viewBox='0 0 13 13'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                      fill='#3361FF'
                    />
                  </svg>
                </Tooltip>
              </button>
            )
          }
          renderTopToolbarCustomActions={({ table }) => {
            return (
              <div
                style={
                  isMobile
                    ? {
                        display: 'flex',
                        flexDirection: 'column-reverse'
                      }
                    : { display: 'flex' }
                }
              >
                {((userPermissionsArr &&
                  userPermissionsArr.filter(permissions => permissions.level3)
                    .length) ||
                  UserIsAdmin) && (
                  <Button
                    size='small'
                    onClick={handleCreateRole}
                    className='m-2'
                    style={
                      isMobile
                        ? {
                            fontSize: 10,
                            whiteSpace: 'nowrap',
                            color: '#3361FF',
                            backgroundColor: '#E4F3FD'
                          }
                        : {
                            color: '#3361FF',
                            backgroundColor: '#E4F3FD'
                          }
                    }
                    variant='contained'
                  >
                    Create Role
                    <svg
                      className='ms-2'
                      width='11'
                      height='10'
                      viewBox='0 0 11 10'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Button>
                )}
              </div>
            );
          }}
        />
      )}
    </div>
  );

  return (
    <>
      <MetaTags>
        <title>
          {' '}
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Roles & Permissions | Shiptechpro'
            : 'Roles & Permissions | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {currentView === 'list' ? renderRoleList() : renderRoleForm()}
    </>
  );
}

export default RoleManagement;
